module.exports = __webpack_public_path__ + "img/9-filters-08.83adae76.svg";